import { defineMessages } from 'react-intl';

export default defineMessages({
  primaryText: {
    id: 'USER_CREATE_LIST_ITEM.primaryText',
    defaultMessage: 'Create a New User',
  },
  inputEmail: {
    id: 'USER_CREATE_LIST_ITEM.inputEmail',
    defaultMessage: 'Email',
  },
  inputPassword: {
    id: 'USER_CREATE_LIST_ITEM.inputPassword',
    defaultMessage: 'Password',
  },
  inputSubmit: {
    id: 'USER_CREATE_LIST_ITEM.inputSubmit',
    defaultMessage: 'Create User',
  },
});



// WEBPACK FOOTER //
// ./components/molecules/UserCreateListItem/messages.js